import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import MobileBottomNav from "@/components/feature/MobileBottomNav";
import MobileFloatingCTA from "@/components/feature/MobileFloatingCTA";
import BackToTop from "@/components/feature/BackToTop";
import RecentlyViewedStrip from "@/components/feature/RecentlyViewedStrip";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
        <RecentlyViewedStrip />
        <MobileBottomNav />
        <MobileFloatingCTA />
        <BackToTop />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
